// js/common/utilities/media-query.js
function matchesMediaQuery(breakpointName) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).matches;
}
function mediaQueryListener(breakpointName, func) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).addEventListener("change", func);
}

function debounce(func, wait) {
  let timeout;
  return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
class SubscribePicker extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.optionSelectors = Array.from(this.querySelectorAll("[data-subscribe-selector]"));
    const scope = this.closest('form') || this.closest('[data-product-section]') || this.getRootNode();
    this.optionSelectorsVariants = Array.from(scope.querySelectorAll(".subscription-variants"));
    this.subscribeInput = scope.querySelector('input[name="selling_plan"]');
    console.log('connected subscribe picker');
    this.optionSelectorsVariants.forEach((optionSelector) => {
      if(optionSelector.querySelector('input').checked){
        console.log(optionSelector.querySelector('input'));
      this.loadSubscriptions(optionSelector.querySelector('input'));
      }
      optionSelector.querySelector('input').addEventListener("change", this.loadSubscriptions.bind(this));
      if(optionSelector.querySelector('select')){
      optionSelector.querySelector('select').addEventListener("change", this.loadSubscriptionsDropdown.bind(this));
      }
    });
  }
  loadSubscriptions(e) {
    console.log('load subscription');
    var _this = this;
    if (e.target != null) {
      var subscribeId = e.target.getAttribute('data-subscription');
      if(subscribeId != ''){
      _this.subscribeInput.value = subscribeId;
      _this.changeSubscriptionUrl(subscribeId);}else{
      _this.disableSubsription();
      }
    } else if(e != null){
      var subscribeId = e.getAttribute('data-subscription');
      if(subscribeId != ''){
      _this.subscribeInput.value = subscribeId;
      _this.changeSubscriptionUrl(subscribeId);
      }else{
      _this.disableSubsription();
      }
    } else {
      _this.disableSubsription();
    }
  }
  loadSubscriptionsDropdown(e) {
    var _this = this;
    if (e.target.value != '') {
      var subscribeId = e.target.value;
      e.target.closest('.subscription-variants').querySelector('input').checked = true;
      _this.subscribeInput.value = subscribeId;
      _this.changeSubscriptionUrl(subscribeId);
    } else {
      e.target.closest('.subscription-variants').querySelector('input').checked = false;
      disableSubsription();
    }
  }
  changeSubscriptionUrl(subscribeId) {
    if (history.pushState) {
      let searchParams = new URLSearchParams(window.location.search);
      if (subscribeId != undefined && subscribeId != '') {
        searchParams.set('selling_plan', subscribeId);
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.pushState({
          path: newurl
        }, '', newurl);
      } else {
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('selling_plan');
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.pushState({
          path: newurl
        }, '', newurl);
      }
    }
  }
  disableSubsription(){
  var _this = this;
  _this.subscribeInput.value = '';
  _this.changeSubscriptionUrl();
  }
};

window.customElements.define("subscribe-picker", SubscribePicker);

// Drives the subscription frequency <select> in blocks/subscribe-dropdown.liquid. It keeps its
// parent variant's radio data-subscription in sync with the chosen plan (so SubscribePicker sets
// the right selling_plan on variant/tab changes) and mirrors the choice onto the form's hidden
// selling_plan input when its variant is the active one.
class SubscribePlanDropdown extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector("select");
    if (!this.select) return;

    // The dropdown lives inside its variant's .subscription-variants radio container.
    this.variantContainer = this.closest(".subscription-variants");
    this.variantRadio = this.variantContainer?.querySelector('input[type="radio"]');
    this.form = document.forms[this.getAttribute("form")] || this.closest("form");
    this.sellingPlanInput = (this.form || document).querySelector('input[name="selling_plan"]');

    this.syncPlan(this.select.value);
    this.select.addEventListener("change", () => this.syncPlan(this.select.value));
  }
  syncPlan(planId) {
    // Keep the parent variant radio's plan id current. SubscribePicker reads data-subscription
    // whenever the variant/tab is (re)selected (e.g. x-tabs-lumity's default selection and
    // editor-state restore), so feeding it the chosen plan stops it from clearing selling_plan.
    if (this.variantRadio) this.variantRadio.setAttribute("data-subscription", planId || "");

    // If this variant is the active one, reflect the choice on the form input immediately.
    // (On first load the radio is checked later by x-tabs-lumity, which then sets it via
    // SubscribePicker using the data-subscription we just wrote.)
    const isActive = this.variantRadio ? this.variantRadio.checked : true;
    if (this.sellingPlanInput && isActive) {
      this.sellingPlanInput.value = planId || "";
      this.sellingPlanInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
};

window.customElements.define("subscribe-plan-dropdown", SubscribePlanDropdown);



class VariantInformation extends HTMLElement {
  constructor() {
    super();
    this.variantInfoContainers = document.querySelectorAll(".variant-information");
    this.variantInfoHolders = document.querySelectorAll("variant-information-inline");
    this.subscribeWidget = document.querySelector('recharge-subscribe-widget');
    this.subscribeInput = document.querySelector('input[name="selling_plan"]');
    this.variantInput = document.querySelector('input[name="id"]');
    this.masterSelector = document.forms[this.getAttribute("form")];
    this.loadVariantInfo();
    document.addEventListener('tab:change', () => this.loadBadgeInfo());



    if (this.variantInput) {
      this.variantInput.addEventListener('change', () => {
        this.loadVariantInfo();
        this.loadBadgeInfo();
      });
    }

    if (Shopify.designMode) {
      this.variantInfoContainers.forEach(VariantInfo => {
        const section = VariantInfo.closest(".shopify-section");
        if (section) {
          section.addEventListener("shopify:section:select", () => {
            this.innerHTML = VariantInfo.innerHTML;
          });
        }
      });
    }
  }

  connectedCallback() {
    // Optionally, load info on connect
    this.loadCurrentVariantInfo(this.subscribeInput.value, this.variantInput.value);
    this.loadBadgeInfo();
  }

  loadVariantInfo() {
    const variantId = this.variantInput?.value;
    const hasSubscription = this.subscribeInput?.value !== '';
    console.log('load variant information');
    this.variantInfoHolders.forEach(VariantHolder => {
      const holderVariantId = VariantHolder.getAttribute('variant-id');
      const isOnetime = VariantHolder.getAttribute('for-variant')?.includes('onetime');
      if (
        (holderVariantId === variantId && hasSubscription) ||
        (holderVariantId === variantId && !hasSubscription && isOnetime)
      ) {
        VariantHolder.classList.add('variant-transition');
        VariantHolder.style.height = 'auto';
      } else {
        VariantHolder.classList.remove('variant-transition');
        VariantHolder.style.height = '0px';
      }
    });
  }

  loadBadgeInfo() {
    console.log('load badge');
    const variantId = this.variantInput?.value;
    const hasSubscription = this.subscribeInput?.value !== '';
    document.querySelectorAll('.product-badge-hide').forEach(item => item.classList.add('hidden'));
    const badgeId = hasSubscription
      ? `badge-for-variant-${variantId}-subscribe-save`
      : `badge-for-variant-${variantId}`;
    const badge = document.getElementById(badgeId);
    console.log(badgeId);
    console.log(badge);
    if (badge) badge.classList.remove('hidden');
  }

  loadCurrentVariantInfo(subscriptionId, variantId) {
    this.variantInfoContainers.forEach(VariantInfo => {
      const forVariant = VariantInfo.getAttribute('for-variant');
      this.variantInfoHolders.forEach(VariantHolder => {
        if (VariantHolder.getAttribute('for-variant') === forVariant) {
          VariantHolder.innerHTML = VariantInfo.innerHTML;
        }
      });
    });
  }
}

window.customElements.define("variant-information", VariantInformation);


class MasonryGrid extends HTMLElement {
  constructor() {
    super();
    if (matchesMediaQuery("sm-max")) {
    }else{
    new Rellax('.rellax', {center: true});
    }
  }
  connectedCallback() {

  }
};

window.customElements.define("masonry-grid", MasonryGrid);


// js/common/overlay/modal.js 
import { Modal } from "theme";
import { animate as animate5 } from "vendor";
var ModalInline = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue); // Call the base class method

    if (name === 'open') {
      if(newValue === ''){
        animate5(this.closest('.ingredients'), {minHeight:[0, this.scrollHeight + 'px'] },{ duration: 0.2})
      }else{
        this.closest('.ingredients').style.minHeight = 'auto';
      }
    }
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "modal-inline-template";
  }
  get shouldLock() {
    return false;
  }
  get shouldAppendToBody() {
    return false;
  }
  get open() {
    return this.hasAttribute("open");
  }
  createEnterAnimationControls() {
  return animate5(this, { opacity: [0, 1] }, { duration: 0.2 });

  }
  createLeaveAnimationControls() {
  return animate5(this, { opacity: [1, 0] }, { duration: 0.2 }); 
  }
};
if (!window.customElements.get("inline-modal")) {
  window.customElements.define("inline-modal", ModalInline);
}

// js/common/navigation/tabs.js
import { Delegate as Delegate10, timeline as timeline6 } from "vendor";
class VTabs extends HTMLElement {
  #componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
  #buttons = [];
  #panels = [];
  #delegate = new Delegate10(this);

  constructor() {
    super();
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.#buttons.indexOf(event.target));
    }
    this.#delegate.on("click", 'button[role="tab"]', this.#onButtonClicked.bind(this));
    this.shadowRoot.addEventListener("slotchange", this.#onSlotChange.bind(this));
    this.addEventListener("keydown", this.#handleKeyboard.bind(this));
  }

  static get observedAttributes() {
    return ["selected-index"];
  }

  connectedCallback() {
    this.#setupComponent();
    this.selectedIndex = this.selectedIndex;
  }

  disconnectedCallback() {
    this.#delegate.destroy();
  }

  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.3;
  }

  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }

  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.#buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.#buttons.forEach((button, index) => {
      if (button != null) {
        button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false");
        if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
          this.transition(this.#panels[parseInt(oldValue)], this.#panels[parseInt(newValue)]);
        }
      }
    });
  }

  async transition(fromPanel, toPanel) {
    fromPanel.hidden = true;
    toPanel.hidden = false;
    if (matchesMediaQuery("sm-max")) {
      await timeline6([
        [toPanel, { height: ["0%", "100%"] }, { duration: 1 }]
      ]).finished;
      this.style.removeProperty("height");
    } else {
      await timeline6([
        [toPanel, { width: ["0%", "100%"] }, { duration: 1 }]
      ]).finished;
    }
    this.style.removeProperty("width");
  }

  #setupComponent() {
    const assigned = Array.from(this.shadowRoot.querySelector('slot[name="tab"]').assignedNodes());
    this.#buttons = assigned
      .map(item => item.matches?.("button") ? item : item.querySelector?.("button"))
      .filter(item => item != null);
    this.#panels = assigned
      .map(item => item.matches?.("div") ? item : item.querySelector?.("div"))
      .filter(item => item != null);
    this.#buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${this.#componentID}-${index}`);
      button.id = `tab-${this.#componentID}-${index}`;
    });
    this.#panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${this.#componentID}-${index}`);
      panel.id = `tab-panel-${this.#componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
    this.style.setProperty("--item-count", this.#buttons.length.toString());
  }

  #onButtonClicked(event, button) {
    this.selectedIndex = this.#buttons.indexOf(button);
  }

  #onSlotChange() {
    this.#setupComponent();
  }

  #handleKeyboard(event) {
    const index = this.#buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.#buttons.length) % this.#buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.#buttons.length) % this.#buttons.length;
    }
    this.#buttons[this.selectedIndex].focus();
  }
}
if (!window.customElements.get("v-tabs")) {
  window.customElements.define("v-tabs", VTabs);
}

// js/common/navigation/tabs.js
import { Delegate as Delegate5, animate as animate10, timeline as timeline10 } from "vendor";
class InlineTabs extends HTMLElement {
  #componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
  #buttons = [];
  #panels = [];
  #delegate = new Delegate5(this);

  constructor() {
    super();
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.#buttons.indexOf(event.target));
    }
    this.#delegate.on("click", 'button[role="tab"]', this.#onButtonClicked.bind(this));
    this.shadowRoot.addEventListener("slotchange", this.#onSlotChange.bind(this));
    this.addEventListener("keydown", this.#handleKeyboard.bind(this));
  }

  static get observedAttributes() {
    return ["selected-index"];
  }

  connectedCallback() {
    this.#setupComponent();
    this.selectedIndex = this.selectedIndex;
  }

  disconnectedCallback() {
    this.#delegate.destroy();
  }

  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.3;
  }

  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }

  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.#panels.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.#buttons.forEach((button) => button.setAttribute("aria-selected", button.getAttribute('select-index') == newValue ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this.transition(this.#panels[parseInt(oldValue)], this.#panels[parseInt(newValue)]);
    }
  }

  async transition(fromPanel, toPanel) {
    const beforeHeight = this.clientHeight;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await timeline10([
      [this, { height: [`${beforeHeight}px`, `${this.clientHeight}px`], overflow: ["hidden", "visible"] }, { duration: 0, easing: [0.85, 0, 0.15, 1] }],
      [toPanel, { opacity: [0, 1] }, { duration: this.animationDuration, at: "+0.1" }]
    ]).finished;
    await animate10(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    this.style.removeProperty("height");
  }

  #setupComponent() {
    this.#buttons = Array.from(this.querySelectorAll('button.tab-selector'));
    this.#panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.#panels.forEach((panel, index) => {
      const buttons = panel.querySelectorAll('button.tab-selector');
      const button_index = index;
      buttons.forEach((button, index) => {
        button.setAttribute("role", "tab");
        button.setAttribute("select-index", index);
        button.setAttribute("aria-controls", `tab-panel-${this.#componentID}-${index}`);
        button.id = `button-${this.#componentID}-${index}-${button_index}`;
      });
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${this.#componentID}-${index}`);
      panel.id = `tab-panel-${this.#componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
    this.style.setProperty("--item-count", this.#buttons.length.toString());
  }

  #onButtonClicked(event, button) {
    this.selectedIndex = button.getAttribute('select-index');
  }

  #onSlotChange() {
    this.#setupComponent();
  }

  #handleKeyboard(event) {
    const index = this.#buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.#buttons.length) % this.#buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.#buttons.length) % this.#buttons.length;
    }
    this.#buttons[this.selectedIndex].focus();
  }
}
if (!window.customElements.get("inline-tabs")) {
  window.customElements.define("inline-tabs", InlineTabs);
}

import { animate as animate20, timeline as timeline20 } from "vendor";
class TabsWithMedia extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('details');
    this.media = this.querySelectorAll('.media-panel');
    this.style.minHeight = this.media[0].clientHeight + 'px';
  }
  connectedCallback() {
    this.tabs.forEach((details, index) => {
      details.setAttribute('select-index', index);
      details.addEventListener("click", e => {
        this.closeOthers(e);
        this.openMedia(e);
      });
    });
  }
  disconnectedCallback() {
    this.tabs.forEach((details) => {
      details.removeEventListener("click");
    });
  }
  /**
   * --------------------------------------------------------------------------
   * GETTERS AND SETTERS
   * --------------------------------------------------------------------------
   */
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.3;
  }
  closeOthers(e){
    this.tabs.forEach((details, index) => {
    if(details != e.target.closest('details')){
    details.setAttribute('aria-expanded', false);  
    }
    });
  }
  openMedia(e){
    var oldValue = this.selectedIndex;
    var newValue = e.target.closest('details').getAttribute('select-index');
    if (oldValue !== null && oldValue !== newValue) {
      this.selectedIndex = newValue;
      this.transition(this.media[parseInt(newValue)]);
    }   
  }
  async transition(toPanel) {
    var image1 = toPanel.querySelector('.img-one');
    var image2 = toPanel.querySelector('.img-two');
    toPanel.hidden = false;
    toPanel.parentNode.style.minHeight = toPanel.clientHeight + 'px';
    this.media.forEach(media =>{
      if(media != toPanel){
      animate20(media, { zIndex: [1, 0] }, { duration: this.animationDuration });
      }  
      });
    timeline20([
      [toPanel, { zIndex: [0, 1], opacity: [0, 1] }, { duration: this.animationDuration, at: "+0.1" }],
      [image1, { transform: ["translateX(50px)", "translateX(0px)"], opacity: [0, 1] }, { duration: this.animationDuration, at: "+0.1" }],
      [image2, { transform: ["translateX(-50px)", "translateX(0px)"], opacity: [0, 1] }, { duration: this.animationDuration, at: "+0.1" }],
    ]);
    this.media.forEach(media =>{
      if(media != toPanel){
      animate20(media, { opacity: [1, 0] }, { duration: this.animationDuration });
      media.hidden = true;
      }  
      });
  }  
};
 
window.customElements.define("tabs-with-media", TabsWithMedia);

import { Tabs } from "theme";
class TabsLumityNew extends Tabs {
  constructor() {
    super(); // always call super() first in the constructor. This also calls the extended class' constructor.
    this.isTransitioning = false; // Flag to prevent multiple transitions
    this.masterSelector = document.forms[this.getAttribute("form")];
  }

  connectedCallback() {
    super.connectedCallback();

    // Defer so shadow-slot assignment and SubscribePicker listeners are ready
    if (!Shopify.designMode) requestAnimationFrame(() => {
      const activePanel = this.querySelector('[role="tabpanel"]:not([hidden])');
      if (!activePanel) return;
      const defaultOption = activePanel.querySelector('.subscription-variants-selected');
      if (defaultOption) {
        const radio = defaultOption.querySelector('input[type="radio"]');
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        this.masterSelector?.dispatchEvent(new CustomEvent('tab:change', { bubbles: true }));
      }
    });

    if (Shopify.designMode) requestAnimationFrame(() => {
      this._restoreEditorState();
      this.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) this._saveEditorState();
      });
      this.addEventListener('shopify:block:select', (e) => {
        const panel = e.target.closest('[role="tabpanel"]');
        if (!panel || !panel.hidden) return;
        const idx = [...this.querySelectorAll('[role="tabpanel"]')].indexOf(panel);
        if (idx !== -1) this.selectedIndex = idx;
      });
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
  }

  async transition(fromPanel, toPanel) {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    // Always switch panel visibility
    fromPanel.hidden = true;
    fromPanel.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.checked = false;
    });
    toPanel.hidden = false;

    // Subscription-specific: activate the selected variant and notify other components
    const subscriptions_available = toPanel.querySelectorAll('.subscription-variants-selected');
    if (subscriptions_available.length !== 0) {
      const subRadio = subscriptions_available[0].querySelector('input[type="radio"]');
      if (subRadio) { subRadio.checked = true; subRadio.dispatchEvent(new Event('change', { bubbles: true })); }
      this.masterSelector.dispatchEvent(new CustomEvent('tab:change', { bubbles: true }));
      const container = subscriptions_available[0].querySelector('variant-information-inline');
      if (container) container.style.height = 'auto';
    }

    if (Shopify.designMode) this._saveEditorState();
    this.isTransitioning = false;
  }

  _editorStateKey() {
    return `lumity-widget-state-${this.getAttribute('handle')}`;
  }

  _saveEditorState() {
    console.log('should save state');
    const panels = this.querySelectorAll('[role="tabpanel"]');
    const tabIndex = Array.from(panels).findIndex(p => !p.hidden);
    const checkedRadio = this.querySelector('input[type="radio"]:checked');
    sessionStorage.setItem(this._editorStateKey(), JSON.stringify({
      tabIndex,
      radioId: checkedRadio?.id || null
    }));
  }

  _restoreEditorState() {
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(this._editorStateKey())); } catch { return; }
    if (!saved) return;

    if (saved.tabIndex !== undefined && saved.tabIndex !== this.selectedIndex) {
      this.selectedIndex = saved.tabIndex;
    }

    if (saved.radioId) requestAnimationFrame(() => {
      const radio = this.querySelector(`#${saved.radioId}`);
      radio?.nextElementSibling?.click(); 
    });
  }
};
customElements.define('x-tabs-lumity', TabsLumityNew);


class AccordionDisclosureGroup extends HTMLElement {
  constructor() {
    super(); // always call super() first in the constructor. This also calls the extended class' constructor.
    this.accordions = this.querySelectorAll('details');
  }
  connectedCallback() {
    this.accordions.forEach((details) => {
      details.addEventListener("click", this.closeOthers.bind(this), true);
    });
  }
  disconnectedCallback() {
    if(this.accordions){
    this.accordions.forEach((details) => {
      details.removeEventListener("click", this.closeOthers.bind(this), true);
    });
    }
  }
  closeOthers(e){ 
  var _this = this;
  _this.accordions.forEach((details) => {
  if(details != e.target.closest('details')){
  details.setAttribute('aria-expanded', false);  
  }
  if(details == e.target.closest('details') && e.target.closest('details').hasAttribute('aria-expanded="true"')){
  details.setAttribute('aria-expanded', false);
  }
  });
  }
};
customElements.define("accordion-group", AccordionDisclosureGroup);



class TruncateTextComponent extends HTMLElement {
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: 'open' });
    this._fullText = this.textContent.trim();
    this._maxCharsMobile = parseInt(this.getAttribute('max-chars-mobile')) || 0;
    this._maxCharsDesktop = parseInt(this.getAttribute('max-chars-desktop')) || 0;

    if ((matchesMediaQuery("sm-max") && this._maxCharsMobile > 0) ||
    (!matchesMediaQuery("sm-max") && this._maxCharsDesktop > 0)) {
  if (this._fullText.length > (matchesMediaQuery("sm-max") ? this._maxCharsMobile : this._maxCharsDesktop)) {
    this._truncatedText = this._fullText.substring(0, (matchesMediaQuery("sm-max") ? this._maxCharsMobile : this._maxCharsDesktop));
    this._isOpen = false;
    this.createTruncate();
  } else {
    this._isOpen = true;
    this.createTruncateWithoutButton();
  }
} else {
  this._isOpen = true;
  this.createTruncateWithoutButton();
}
  }

  createTruncate() {
    this._shadowRoot.innerHTML = `
      <style>
        .toggleBtn {
          cursor: pointer;
          text-decoration: underline;
        }
      </style>
      <span class="textContainer">${this._isOpen ? this._fullText : this._truncatedText}</span>
      <span class="toggleBtn">${this._isOpen ? 'Read Less' : 'Read More'}</span>
    `;

    this._textContainer = this._shadowRoot.querySelector('.textContainer');
    this._toggleBtn = this._shadowRoot.querySelector('.toggleBtn');

    this._toggleBtn.addEventListener('click', () => this.toggleContent());
  }

  toggleContent() {
    this._isOpen = !this._isOpen;
    this._textContainer.textContent = this._isOpen ? this._fullText : this._truncatedText;
    this._toggleBtn.textContent = this._isOpen ? 'Read Less' : 'Read More';
  }
  createTruncateWithoutButton() {
    this._shadowRoot.innerHTML = `
      <span class="textContainer">${this._fullText}</span>
    `;
    this._textContainer = this._shadowRoot.querySelector('.textContainer');
  }
}

customElements.define('truncate-text-component', TruncateTextComponent);

class YesNoComponent extends HTMLElement {
  constructor() {
    super();
    // Initial state: no buttons are shown
    this.showButtons = false;
    this.submitFormHandler = this.submitForm.bind(this);
    this.checkInputs();
    this.checkTerms();
  }

  // Function to check if both Yes and No inputs are clicked
  checkInputs() {
    this.inputs = Array.from(this.querySelectorAll('input[type="radio"][value="Yes"]'));
    const buttonsDivYes = this.querySelector('.show-button-yes');
    const buttonsDivNo = this.querySelector('.show-button-no');

    if (this.inputs.every(input => input.checked == true )) {
      buttonsDivYes.style.display = 'block';
      buttonsDivNo.style.display = 'none';
    } else {
      buttonsDivYes.style.display = 'none';
      buttonsDivNo.style.display = 'block';
    }
  }
  checkTerms() {
    this.inputs = Array.from(this.querySelectorAll('input[type="checkbox"]'));
    const buttonsDivYes = this.querySelector('.show-button-yes a');
    const buttonsDivNo = this.querySelector('.show-button-no a');
    if (this.inputs.every(input => input.checked == true )) {
      buttonsDivYes.addEventListener('click', this.submitFormHandler);
      buttonsDivNo.addEventListener('click', this.submitFormHandler);  
      buttonsDivYes.classList.remove('disabled');
      buttonsDivNo.classList.remove('disabled');
    } else {
      buttonsDivYes.removeEventListener('click', this.submitFormHandler);
      buttonsDivNo.removeEventListener('click', this.submitFormHandler);  
      buttonsDivYes.classList.add('disabled');
      buttonsDivNo.classList.add('disabled');
    }
  }

  // Lifecycle method called when the element is connected to the DOM
  submitForm(){ 
  event.preventDefault();
  let redirect_url = event.target.href;
  window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
    window.location.href = redirect_url;
    }
  });
  this.querySelector('form.klaviyo-form button.go156862118').click();
  }
  connectedCallback() {
    const buttonsDivYes = this.querySelector('.show-button-yes');
    const buttonsDivNo = this.querySelector('.show-button-no');
    const radioInputs = this.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(input => {
      input.addEventListener('change', this.checkInputs.bind(this));
    });
    const checkboxInputs = this.querySelectorAll('input[type="checkbox"]');
    checkboxInputs.forEach(input => {
      input.addEventListener('change', this.checkTerms.bind(this));
    });
  }

  // Lifecycle method called when the element is disconnected from the DOM
  disconnectedCallback() {
    const radioInputs = this.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(input => {
      input.addEventListener('change', this.checkInputs.bind(this));
    });
  }
}

// Define the custom element and register it with the custom tag name
customElements.define('yes-no-component', YesNoComponent);

import { ImageWithText } from "theme";
var ValueForMoney = class extends ImageWithText {
  constructor() {
    super();
  }
};
if (!window.customElements.get("value-for-money")) {
  window.customElements.define("value-for-money", ValueForMoney);
}
import { EffectCarousel } from "theme";

gsap.registerPlugin(ScrollTrigger);

class ClinicalTrials extends HTMLElement {
  constructor() {
    super();
    this.setupScrollTrigger();
  }

  connectedCallback() {
  }
  setupScrollTrigger(){

    // Pin the section using GSAP
    let headerHeight = Number(document.querySelector('header').offsetHeight) + Number(document.querySelector('.shopify-section-group-header-group').offsetHeight)
    let startTrigger = "top " + headerHeight + "px";
    if(matchesMediaQuery("sm-max")){
    var scroll_time = "+=1000";
    }
    if(matchesMediaQuery("sm")){
    var scroll_time = "+=1500";
    }
    let tl = gsap.timeline({
      // yes, we can add it to an entire timeline!
      scrollTrigger: {
          trigger: this,
          pin: this, // pin the trigger element while active
          pinSpacing: true,
          start: startTrigger, // when the top of the trigger hits the top of the viewport
          end: scroll_time, // end after scrolling 500px beyond the start
          markers: true,
          smoothChildTiming: true,
          scrub: 0, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
          onUpdate: (self) => console.log("progress:", self.progress)
      }
  });
  
  // add animations and labels to the timeline
  let scrollableHeight = this.querySelector('.scrollable-content').scrollHeight;
  let containerHeight = this.querySelector('.clinical-trial-scroll__container').clientHeight;
  let totalScrollablePixels = scrollableHeight - containerHeight + 50;
  tl.fromTo('.clinical-trial-scroll__container', { scrollTop: 0 }, { scrollTop: totalScrollablePixels });
  }
}

if (!window.customElements.get("clinical-trials")) {
  window.customElements.define("clinical-trials", ClinicalTrials);
}

(function () {
  const SCOPE_SELECTOR = '.js-price-toggle-scope[data-show-price-variants]';

  // Adjust this if your theme uses a different price wrapper class
  const PRICE_SELECTORS = [
    '.price',                 // common
    '.product-price',         // common
    '[data-price]',           // common
    '[data-product-price]',   // common
    '.show-hide-single-price'             // Prestige-ish
  ];

  function parseAllowed(scope) {
    return new Set(
      (scope.getAttribute('data-show-price-variants') || '')
        .split(',')
        .map(s => Number(s.trim()))
        .filter(n => Number.isFinite(n))
    );
  }

  function getVariantId() {
    const input =
      document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action^="/cart/add"] select[name="id"]') ||
      document.querySelector('input[name="id"]:checked');

    if (input?.value) return Number(input.value);

    const v = new URL(location.href).searchParams.get('variant');
    return v ? Number(v) : null;
  }

  function findPriceEl(scope) {
    for (const sel of PRICE_SELECTORS) {
      const el = scope.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function update() {
    document.querySelectorAll(SCOPE_SELECTOR).forEach(scope => {
      const allowed = parseAllowed(scope);
      const vid = getVariantId();

      const priceEl = findPriceEl(scope);
      if (!priceEl) return; // if we can't find it, don't break anything

      const shouldShow = vid != null && allowed.has(vid);
      priceEl.style.display = shouldShow ? '' : 'none';
    });
  }

  document.addEventListener('DOMContentLoaded', update);

  document.addEventListener('change', (e) => {
    if (e.target.closest('form[action^="/cart/add"], variant-selects, variant-radios, [data-variant-picker]')) {
      requestAnimationFrame(update);
      setTimeout(update, 0);
    }
  });

  // Catch Prestige re-renders
  new MutationObserver(update).observe(document.documentElement, { childList: true, subtree: true });

  // Catch URL updates
  window.addEventListener('popstate', update); 
})();

class GalleryBadgeController extends HTMLElement {
  connectedCallback() {
    const formId = this.getAttribute('form');
    const form = document.getElementById(formId);
    this.variantInput = form?.querySelector('input[name="id"]')
      ?? document.querySelector('input[name="id"]');
    this.planInput = document.querySelector('input[name="selling_plan"]');

    this._update = this.updateBadges.bind(this);
    this.variantInput?.addEventListener('change', this._update);
    this.planInput?.addEventListener('change', this._update);
    document.addEventListener('tab:change', this._update);

    this.initStaticBadges();
    this.updateBadges();
  }

  disconnectedCallback() {
    this.variantInput?.removeEventListener('change', this._update);
    this.planInput?.removeEventListener('change', this._update);
    document.removeEventListener('tab:change', this._update);
  }

  initStaticBadges() {
    document.querySelectorAll('gallery-badge-config').forEach(config => {
      if (config.hasAttribute('data-variant-match')) return;

      const position = config.dataset.mediaPosition;
      const container = document.querySelector(
        `gallery-badge-container[data-media-position="${position}"]`
      );
      if (!container) return;

      const badge = document.createElement('div');
      badge.className = `product-badge badge-${config.dataset.badgePosition}`;
      badge.style.width = `${config.dataset.badgeSize}%`;
      badge.innerHTML = config.innerHTML;
      container.appendChild(badge);
    });
  }

  updateBadges() {
    const variantId = this.variantInput?.value;
    const hasPlan = (this.planInput?.value ?? '') !== '';

    document.querySelectorAll('gallery-badge-container [data-dynamic-badge]').forEach(b => b.remove());

    document.querySelectorAll('gallery-badge-config').forEach(config => {
      if (!config.hasAttribute('data-variant-match')) return;

      const configVariantId = config.dataset.variantId;
      const isSubscription = config.dataset.isSubscription === 'true';
      if (configVariantId !== variantId) return;
      if (isSubscription !== hasPlan) return;

      const position = config.dataset.mediaPosition;
      const container = document.querySelector(
        `gallery-badge-container[data-media-position="${position}"]`
      );
      if (!container) return;

      const badge = document.createElement('div');
      badge.className = `product-badge badge-${config.dataset.badgePosition}`;
      badge.style.width = `${config.dataset.badgeSize}%`;
      badge.innerHTML = config.innerHTML;
      badge.dataset.dynamicBadge = 'true';
      container.appendChild(badge);
    });
  }
}

if (!customElements.get('gallery-badge-controller')) {
  customElements.define('gallery-badge-controller', GalleryBadgeController);
}

class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (template instanceof HTMLTemplateElement) {
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.append(template.content.cloneNode(true));
      }
    }
  }
}

if (!window.customElements.get("declarative-shadow-element")) {
  window.customElements.define("declarative-shadow-element", DeclarativeShadowElement);
}
